import { lazy } from 'react'
import { LANG } from "../language/lang";
import HomeIcon from '@mui/icons-material/Home';


const PublicLayout = lazy(() => import('../layouts/PublicLayout'))
const CabinetLayout = lazy(() => import('../layouts/CabinetLayout'))
const CreatedLayout = lazy(() => import('../layouts/CreatedLayout'))
const ProtectedRoute = lazy(() => import('../routers/ProtectedRoute'))

const Home = lazy(() => import('../pages/Home'))
const NotFound = lazy(() => import('../pages/NotFound'))
const Profile = lazy(() => import('../pages/Cabinet/Profile'))
const Pages = lazy(() => import('../pages/Pages'))
const Contacts = lazy(() => import('../pages/Contacts'))
const About = lazy(() => import('../pages/About'))
const CreatedQR = lazy(() => import('../pages/CreatedQR'));
const Orders = lazy(() => import('../pages/Cabinet/Orders/index.js'))
const Balance = lazy(() => import('../pages/Cabinet/Balance/index.js'))

const ROUTE = [
    {
        path: '/',
        component: <PublicLayout />,
        componentName: 'PublicLayout',
        children: [
            {
                index: true,
                component: <Home />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_HOME"),
                icon: <HomeIcon fontSize="small" />,
            },
            {
                path: 'about',
                component: <About />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_ABOUT"),
            },
            {
                path: 'contacts',
                component: <Contacts />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_CONTACTS"),
            },
            {
                path: 'cookie-policy',
                component: <Pages />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_COOKIE_POLICY"),
            },

            {
                path: 'return-policy',
                component: <Pages />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_RETURN_POLICY"),
            },

            {
                path: 'privacy-policy',
                component: <Pages />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_RETURN_POLICY"),
            },

            {
                path: 'rules',
                component: <Pages />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_RETURN_POLICY"),
            },


        ],
    },

    {
        path: '/cabinet',
        component: <ProtectedRoute />,
        componentName: 'ProtectedRoute',
        children: [
            {
                component: <CabinetLayout />,
                componentName: 'CabinetLayout',
                children: [
                    {
                        index: true,
                        component: <Profile />,
                    },
                    {
                        path: 'profile',
                        component: <Profile />,
                    },
                    {
                        path: 'orders',
                        component: <Orders />,
                    },
                    {
                        path: 'balance',
                        component: <Balance />,
                    },
                    
                ],
            },
        ],
    },

    {
        path: '/create',
        component: <CreatedLayout />,
        componentName: 'CreatedLayout',
        children: [
            {
                component: <CreatedLayout />,
                componentName: 'CreatedLayout',
                children: [
                    {
                        index: true,
                        component: <CreatedQR />,
                    }
                ],
            },
        ],
    },

    {
        path: '*',
        component: <NotFound />,
    },
]

export default ROUTE